var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9728 20.3683C8.7338 20.3683 5.9668 19.8783 5.9668 17.9163C5.9668 15.9543 8.7158 14.2463 11.9728 14.2463C15.2118 14.2463 17.9788 15.9383 17.9788 17.8993C17.9788 19.8603 15.2298 20.3683 11.9728 20.3683Z",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9731 11.4488C14.0991 11.4488 15.8231 9.72576 15.8231 7.59976C15.8231 5.47376 14.0991 3.74976 11.9731 3.74976C9.84706 3.74976 8.12306 5.47376 8.12306 7.59976C8.11706 9.71776 9.82706 11.4418 11.9461 11.4488H11.9731Z",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3623 10.3915C19.5993 10.0605 20.5113 8.93254 20.5113 7.58954C20.5113 6.18854 19.5183 5.01854 18.1963 4.74854",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9434 13.5444C20.6974 13.5444 22.1954 14.7334 22.1954 15.7954C22.1954 16.4204 21.6784 17.1014 20.8944 17.2854",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58359 10.3915C4.34559 10.0605 3.43359 8.93254 3.43359 7.58954C3.43359 6.18854 4.42759 5.01854 5.74859 4.74854",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.002 13.5444C3.248 13.5444 1.75 14.7334 1.75 15.7954C1.75 16.4204 2.267 17.1014 3.052 17.2854",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.abfd19ae71fc79e609c813c561462278.svg";
export { ForwardRef as ReactComponent };